import { useTheme } from "@mui/styles";
import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getAdaptiveFontSize } from "../../../utils/styling.utils";

const Title = ({ children, styles = {} }) => {
  const theme = useTheme();
  //Media Queries
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };

  return (
    <div
      style={{
        fontFamily: "noto-sans",
        fontSize: getAdaptiveFontSize({
          screenWidthHooks,
          fontSize: 4,
        }),
        color: theme.COLORS.WHITE.backgroundWhite,
        ...styles,
      }}
    >
      {children}
    </div>
  );
};

export default Title;
